/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Footer_Badges_Add_TitleInputs */

const en_admin_footer_badges_add_title = /** @type {(inputs: Admin_Footer_Badges_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a badge`)
};

/**
* | output |
* | --- |
* | "Add a badge" |
*
* @param {Admin_Footer_Badges_Add_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_footer_badges_add_title = /** @type {((inputs?: Admin_Footer_Badges_Add_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Footer_Badges_Add_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_footer_badges_add_title(inputs)
});
export { admin_footer_badges_add_title as "admin.footer_badges.add_title" }